// External libraries
import flowRight from 'lodash/flowRight';
import { connect } from 'react-redux';

// Zocdoc libraries
import { withCustomMetrics } from '@zocdoc/frontend-metrics';
import {
    trackClickGoogleLogin,
    trackClickFacebookLogin,
    trackClickAppleLogin,
} from '@zocdoc-frontend-common/components-sign-in-form/components/SignInFormPatientProviderMode/SignInFormPatientProviderModeActions';
import { buildSsoLoginUrl } from '@zocdoc-frontend-common/utils-react/buildSsoLoginUrl';

// BWA
import { paths } from '../../paths';
import { pushWithQuery } from '../../utils';
import buildSsoReturnUrl from '../../utils/buildSsoReturnUrl';
import { getReferrerType } from '../../utils/getReferrerType';
import { showLoginModal, closeLoginModal } from '../../actions/SignUpActions';
import { showRememberMeSelector } from '../../../config/ab/selector';
import { formatAppointmentTimeForDisplay } from '../../utils';
import PatientInfoPageContainer from './PatientInfoPageContainer';
import {
    sawLoginModal,
    shouldShowLoginModal,
    shouldShowPatientInfoTransition,
} from '../../selectors/SignUpSelector';
import initialBookingStateSelector from '../../selectors/InitialBookingStateSelector';
import shouldShowNewUsersSsoSelector from '../../selectors/ShouldShowNewUsersSsoSelector';

const mapStateToProps = (state, ownProps) => {
    const initialBookingState = initialBookingStateSelector(state);

    const loggedInUser = initialBookingState.loggedInUser;
    const returnUrl = buildSsoReturnUrl(
        ownProps?.params?.bookingId || '',
        getReferrerType()
    );

    // note that we look at baseAppleLoginUrl here instead
    // of appleLoginUrl because we want to know if the prop was
    // set. buildSsoLoginUrl will always return something for
    // appleLoginUrl

    const formattedAppointmentTime = formatAppointmentTimeForDisplay(
        initialBookingState.appointmentTime,
        initialBookingState.locationTimeZoneId
    );

    const buildOneSsoLoginUrl = url =>
        buildSsoLoginUrl(url, returnUrl, true, true);

    const shouldShowNewUsersSSO = shouldShowNewUsersSsoSelector(state);

    return {
        appleLoginUrl:
            initialBookingState.showAppleLoginButton === 'True'
                ? buildOneSsoLoginUrl(initialBookingState.appleLoginUrl)
                : '',
        facebookLoginUrl: buildOneSsoLoginUrl(
            initialBookingState.facebookLoginUrl
        ),
        formattedAppointmentTime,
        googleLoginUrl: buildOneSsoLoginUrl(initialBookingState.googleLoginUrl),
        showRememberMe: showRememberMeSelector(state),
        locationId: initialBookingState.locationId,
        loggedInUser,
        // BWA still uses monolith naming sometimes :sob:
        providerId: initialBookingState.professionalId,
        returnUrl,
        sawLoginModal: sawLoginModal(state),
        shouldShowLoginModal: shouldShowLoginModal(state),
        shouldShowNewUsersSSO,
        shouldTransition: shouldShowPatientInfoTransition(state),
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onClickAppleLogin: () => dispatch(trackClickAppleLogin()),
    onClickFacebookLogin: () => dispatch(trackClickFacebookLogin()),
    onClickGoogleLogin: () => dispatch(trackClickGoogleLogin()),
    openLoginModal: () => dispatch(showLoginModal()),
    onCloseLoginModal: () => dispatch(closeLoginModal()),
    onSignInSuccess: () => {
        dispatch(
            pushWithQuery(
                `${paths.reviewAndBookPath}/${ownProps.params.bookingId}`
            )
        );
    },
});

export default flowRight(
    connect(mapStateToProps, mapDispatchToProps),
    withCustomMetrics({
        category: 'Booking - Patient Info',
        page: 'Booking',
        section: 'Patient Info View',
    })
)(PatientInfoPageContainer);
